import api from "./api";
import { loaderService } from "../services/loaderService";

class AuthService {
  async login(email, password) {
    loaderService.show();
    try {
      const res = await api.post("/auth/login", { email, password });
      const body = res?.data || {};
      const token = body?.data?.token ?? body?.token ?? null;
      const user = body?.data?.user ?? body?.user ?? null;
      const message = body?.message ?? "";
      const success = !!body?.success ?? false;
      return { token, user, raw: body, message, success };
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  async register(payload) {
    loaderService.show();
    try {
      // POST http://localhost:3000/api/auth/signup
      const res = await api.post("/auth/signup", payload);
      return { status: res.status, data: res.data };
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  async verifyOtp(email, otp) {
    loaderService.show();
    try {
      // POST http://localhost:3000/api/auth/verify-otp
      const res = await api.post("/auth/verify-otp", {
        email,
        otp: Number(otp),
      });
      return { status: res.status, data: res.data };
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  async changePassword({ currentPassword, newPassword, confirmNewPassword }) {
    loaderService.show();
    try {
      const response = await api.post("/auth/change-password", {
        currentPassword,
        newPassword,
        confirmNewPassword,
      });
      return response.data; // expected { success, message }
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  // ✅ Forgot password (send OTP)
  async forgotPassword(email) {
    loaderService.show();
    try {
      const res = await api.post("/auth/forgot-password", { email });
      return res.data; // { success, message }
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  // ✅ Verify password reset OTP
  async verifyPasswordResetOtp({ email, otp }) {
    loaderService.show();
    try {
      const res = await api.post("/auth/verify-password-reset-otp", { email, otp: Number(otp) });
      return res.data; // { success, message }
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }

  // ✅ Reset password
  async resetPassword({ email, password, confirmPassword }) {
    loaderService.show();
    try {
      const res = await api.post("/auth/reset-password", {
        email,
        password,
        confirmPassword,
      });
      return res.data; // { success, message }
    } catch (err) {
      throw err;
    } finally {
      loaderService.hide();
    }
  }
}

export default new AuthService();
